<template>
  <div v-if="isLoggedIn" class="mt-1">
    <v-tabs
      v-model="active"
      color="indigo"
      centered
      dark
      slider-color="yellow"
    >
      <v-tab
        v-for="(status, index) in statuses"
        :key="index"
        ripple
        @click="next(status.status_id)"
      >
        {{ status.title }}
      </v-tab>
      <v-tab-item
        v-for="(status, index) in statuses"
        :key="index"
        
      >
        <div>
          <v-btn
            v-model="projectId" 
            color="indigo darken-2"
            class="ml-4"
            dark
            depressed
            @click="back(projectId)"
            >Back
          </v-btn>
        </div>

        <v-card flat v-if="status.status_id == 1 && active == 0">
          <Inprogress></Inprogress>
        </v-card>
        <v-card flat v-if="status.status_id == 2 && active == 1">
          <Pending></Pending>
        </v-card>
        <v-card flat v-else-if="status.status_id == 4 && active == 3">
          <RejectedTask></RejectedTask>
        </v-card>
        <v-card flat v-else-if="status.status_id == 3 && active == 2">
          <RequiredModification></RequiredModification>
        </v-card>
         <v-card flat v-else-if="status.status_id == 5 && active == 4">
          <CanceledTask></CanceledTask>
        </v-card>
        <v-card flat v-else-if="status.status_id == 6 && active == 5">
          <AcceptedTask></AcceptedTask>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- <div class="text-xs-center mt-3">
      <button class="button" flat @click="next">Next Tab</button>
    </div> -->
  </div>
  <div centered v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4 md4></v-flex>
        <v-flex xs4 md4 align-end>
          <v-card>
            <v-card-text color="indigo">
                You are not logged in!
            </v-card-text>
          </v-card>
          <router-link to="/signin">
            <v-btn color="#ff2e2e"><v-icon>lock_open</v-icon> login</v-btn>
          </router-link>
        </v-flex>
        <v-flex xs4 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Pending from './Pending'
import AcceptedTask from './AcceptedTask'
import RejectedTask from './RejectedTask'
import RequiredModification from './RequiredModification'
import CanceledTask from './CanceledTask'

import {mapGetters} from 'vuex'
import Inprogress from './Inprogress.vue'

  export default {
    data () {
      return {
        active: null,
        projectId:null,
        statuses:[
          {'title':'in progress', 'status_id': 1},
          {'title': 'pending', 'status_id': 2}, 
          {'title': 'required for modification', 'status_id': 3},
          {'title': 'rejected', 'status_id': 4},
          {'title': 'canceled', 'status_id': 5},
          {'title': 'accepted', 'status_id': 6}
        ]
      }
    },
    components: {
      Pending,
      RejectedTask,
      AcceptedTask,
      RequiredModification,
      CanceledTask,
      Inprogress
    },
    computed:{
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg'])     
    },

    created () {
      this.projectId = window.localStorage.getItem('projectId');
      this.statusList(2)
    },

    methods: {

      back(project_id){
        this.$store.dispatch('getProjectDetails',[ project_id, 'client-view'])
      },
      // next (status) {
      //   const active = parseInt(this.active)    
      //   this.statusList(status)
      //   this.active = (this.active < 5) ? this.active + 1 : 0     
      // }, 
      next (status) {
        this.statusList(status)
        this.active = parseInt(status) -1;         
      },     
      statusList: function(taskStatusId){
        // console.log(taskStatusId)
        let taskTableName = window.localStorage.getItem('projectId');
        // this.$store.dispatch('changeTaskStatus', ['task-status', taskStatusId,taskTableName])
        this.$store.dispatch('changeTaskStatus',['task-status', taskStatusId, taskTableName, "", 1, 10])
      }
    }
  }
</script>

<style lang="stylus" scoped>
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color:white;
}
  
</style>